import { getBlockedProductIdsForSelectedIds } from "../../../common/onBoardingWizardFieldTypes/cameraProductsMutualExclusion";

export const handleCreateAutoAddObject = (camerasObject: any) => {
  interface ReturnObject {
    items: any[];
  }

  const returnObject: ReturnObject = {
    items: [],
  };
  const localProducts = JSON.parse(localStorage.products || "[]");
  const productsArray = localProducts.map((product: any) => [
    product.name,
    product.id,
  ]);

  const sanitizeProductsForCamera = (productIds: number[]): number[] => {
    const sanitized: number[] = [];
    productIds.forEach((productId: number) => {
      const blockedForCurrent = getBlockedProductIdsForSelectedIds(
        sanitized,
        productsArray
      );
      if (!blockedForCurrent.has(productId)) {
        sanitized.push(productId);
      }
    });
    return sanitized;
  };

  for (const key in camerasObject) {
    if (key !== "objectId" && key !== "key" && camerasObject[key].products[0]) {
      if (!camerasObject[key].camera) {
        const sanitizedProducts = sanitizeProductsForCamera(
          camerasObject[key].products
        );
        if (sanitizedProducts[0]) {
          returnObject.items.push({
            ...camerasObject[key],
            products: sanitizedProducts,
          });
        }
      }
    }
  }
  return returnObject;
};
